import React, { useState } from 'react';
import { PanelGroup, Panel, PanelResizeHandle } from 'react-resizable-panels';
import { AutoSizer } from 'react-virtualized';
import { useStyles } from './grid-layout-styles';

export function GridLayout({
  LeftPanel,
  BreadcrumbsPanel,
  BodyPanel,
  RightPanel,
}: {
  LeftPanel: React.ReactNode;
  BreadcrumbsPanel: React.ReactNode;
  BodyPanel: React.ReactNode;
  RightPanel?: React.ReactNode;
}) {
  const classes = useStyles();
  const [leftPanelSize, setLeftPanelSize] = useState(30);
  return (
    <div style={{ minHeight: 'calc(100vh - 80px)' }}>
      <AutoSizer disableWidth>
        {({ height }) => (
          <div style={{ height: height, width: '100%', top: 0 }}>
            <div
              style={{
                height: '100%',
                position: 'absolute',
                width: `${leftPanelSize}%`,
              }}
            >
              <div id="G_LEFT_PANEL" className={classes.gridLeftPanelWrapper}>
                <div className={classes.gridLeftPanel}>{LeftPanel}</div>
              </div>
            </div>
          </div>
        )}
      </AutoSizer>
      <PanelGroup direction="horizontal" autoSaveId="resizable-grid">
        <Panel
          defaultSize={15}
          onResize={setLeftPanelSize}
          minSize={10}
          order={0}
        />
        <PanelResizeHandle
          className={classes.handleLeft}
          style={{ left: `${leftPanelSize}%` }}
        />
        <Panel defaultSize={50} order={1}>
          <div className={classes.upperPanel}>{BreadcrumbsPanel}</div>
          <PanelGroup direction="horizontal" autoSaveId="resizable-grid-body">
            <Panel defaultSize={80} order={2}>
              <div style={{ padding: 16 }}>{BodyPanel}</div>
            </Panel>
            <PanelResizeHandle className={classes.handleRight} />
            {RightPanel && (
              <Panel minSize={5} maxSize={20} defaultSize={20} order={3}>
                {RightPanel}
              </Panel>
            )}
          </PanelGroup>
        </Panel>
      </PanelGroup>
    </div>
  );
}
